/**
 * Nosto search / SERP analytics: quick-shop SKU, product image clicks, cart upsell ATC.
 * Loaded from search template after nosto-search.js.
 */
(function () {
  setTimeout(function () {
    var products = document.querySelectorAll('#ProductGridContainer .nosto-product-info');
    products.forEach(function (product) {
      var sku = product.querySelector('.sku-item');
      if (!sku) return;
      sku.addEventListener('click', function () {
        var productCard =
          product.closest('[data-product-id]') || product.closest('.grid-product');
        if (!productCard) {
          console.log('Nosto tracking: Product card not found');
          return;
        }

        var productId = productCard.getAttribute('data-product-id');
        var productUrl = productCard.getAttribute('data-product-url');

        if (!productId || !productUrl) {
          console.log('Nosto tracking: Missing product data', { productId: productId, productUrl: productUrl });
          return;
        }

        if (typeof window.nostojs === 'undefined') {
          console.log('Nosto tracking: Nosto API not available');
          return;
        }

        window.nostojs(function (api) {
          try {
            api.recordSearchAddToCart('serp', { productId: productId, url: productUrl });
            console.log('Nosto tracking: Successfully recorded product quick shop add to cart', { productId: productId });
          } catch (error) {
            console.error('Nosto tracking: Error recording product quick shop add to cart', error, { productId: productId });
          }
        });
      });
    });

    var productImages = document.querySelectorAll('#ProductGridContainer .nosto-product-images');
    productImages.forEach(function (imageElement) {
      imageElement.addEventListener('click', function () {
        var productCard =
          imageElement.closest('[data-product-id]') || imageElement.closest('.grid-product');
        if (!productCard) {
          console.log('Nosto tracking: Product card not found for image');
          return;
        }

        var productId = productCard.getAttribute('data-product-id');
        var productUrl = productCard.getAttribute('data-product-url');

        if (!productId || !productUrl) {
          console.log('Nosto tracking: Missing product data for image', { productId: productId, productUrl: productUrl });
          return;
        }

        if (typeof window.nostojs === 'undefined') {
          console.log('Nosto tracking: Nosto API not available');
          return;
        }

        window.nostojs(function (api) {
          try {
            api.recordSearchClick('serp', { productId: productId, url: productUrl });
            console.log('Nosto tracking: Successfully recorded product click', { productId: productId });
          } catch (error) {
            console.error('Nosto tracking: Error recording product click', error, { productId: productId });
          }
        });
      });
    });
  }, 3000);

  setTimeout(function () {
    var upsellProducts = document.querySelectorAll('#cart-upsell .nosto-list-item');
    upsellProducts.forEach(function (product) {
      var addToCart = product.querySelector('.atc-cart-nosto');
      if (!addToCart) return;
      addToCart.addEventListener('click', function (evt) {
        var productId = product.getAttribute('data-product-id');
        var productUrl = product.getAttribute('data-product-url');

        if (!productId || !productUrl) {
          console.log('Nosto tracking: Missing product data for add-to-cart', { productId: productId, productUrl: productUrl });
        } else if (typeof window.nostojs === 'undefined') {
          console.log('Nosto tracking: Nosto API not available for add-to-cart');
        } else {
          console.log('Nosto tracking: Recording add-to-cart', { productId: productId, productUrl: productUrl });
          window.nostojs(function (api) {
            try {
              api.recordSearchAddToCart('category', { productId: productId, url: productUrl });
              console.log('Nosto tracking: Successfully recorded add-to-cart', { productId: productId });
            } catch (error) {
              console.error('Nosto tracking: Error recording add-to-cart', error, { productId: productId });
            }
          });
        }

        evt.stopPropagation();
        evt.preventDefault();
        theme.SizeDrawer.open(evt, product.getAttribute('data-product-handle'));
      });
    });
  }, 5000);
})();
